import React from 'react';
import styles from './SimilarData.module.css';
import { searchSimilarText } from '../../helper';
import { CloseSvg } from '../../SVGComponents/SVGComponents';

export default function SimilarData({
  searchArray,
  itemSearch,
  textSearch,
  handleClick,
  smallText_1,
  smallText_2,
}) {
  const searchResultArray = searchSimilarText(searchArray, itemSearch, textSearch);

  return (
    <div className={styles.simila_data_wrappe}>
      <div className={styles.simila_data_close_btn} onClick={() => handleClick(false)}>
        <CloseSvg fill="#ccc" />
      </div>

      {searchResultArray && searchResultArray.length ? (
        <div className={styles.simila_data_items_wrapper}>
          {searchResultArray.map((item) => {
            return (
              <div key={item.id}>
                {item[itemSearch]}

                {smallText_1 && item[smallText_1] ? (
                  <small className={'ml_5 op_05'}>({item[smallText_1]})</small>
                ) : (
                  ''
                )}
                {smallText_2 && item[smallText_2] ? (
                  <small className={'ml_5 op_05'}>({item[smallText_2]})</small>
                ) : (
                  ''
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className={'p_10'}>Збігів не знайдено :)</div>
      )}
    </div>
  );
}
